import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { convertEventHandlers } from "./convertEvents.js";
export function convertLifeCycle(component, options) {
  var lifeCycle = {};
  for (var _i = 0, _Object$entries = Object.entries((_component$lifeCycle = component.lifeCycle) !== null && _component$lifeCycle !== void 0 ? _component$lifeCycle : {}); _i < _Object$entries.length; _i++) {
    var _component$lifeCycle;
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      event = _Object$entries$_i[0],
      handler = _Object$entries$_i[1];
    switch (event) {
      case "onMount":
      case "onUnmount":
        {
          var action = convertEventHandlers(handler, options);
          if (action) {
            lifeCycle[event] = action;
          }
          break;
        }
    }
  }
  return Object.keys(lifeCycle).length > 0 ? lifeCycle : undefined;
}
//# sourceMappingURL=convertLifeCycle.js.map